export default "__VITE_ASSET__Bh2R01OX__"